<template>
  <a-spin
    size="large"
    :spinning="loading"
    wrapperClassName="global-spin-wrapper"
  >
    <div class="subscribe-page">
      <a-card class="main-card">
        <div style="margin-bottom: 25px">
          <Step
            :current="$route.query.isfromCamp == 1 ? 2 : 1"
            :isfromCamp="$route.query.isfromCamp == 1 ? true : false"
          ></Step>
        </div>

        <div class="content">
          <div class="left">
            <div class="section-title" :class="[lang]">
              {{ $t("AIselection") }}
            </div>
            <div
              v-if="info.type != 4"
              data-v-564af55a=""
              data-show="true"
              class="ant-alert ant-alert-info alertInfo"
            >
              <span class="ant-alert-message" :class="[lang]">
                <template v-if="info.type != 3">
                  {{ $t("ExplorePrime")
                  }}<a href="javascript:void(0)" @click="showUpgradeModal">{{
                    $t("ExplorePrimeBtn")
                  }}</a>
                </template>
                <template v-else>{{ $t("PrimePlan") }}</template>
              </span>

              <!-- <span class="ant-alert-description"></span> -->
            </div>
            <div v-else style="height: 16px"></div>

            <a-row :gutter="16" class="mb24">
              <a-col :xs="24" :sm="12" class="ai-card-col">
                <a-card
                  :class="{
                    selected: selectedAll || aiType === '2' ? true : false,
                    disabled:
                      selectedAll || (info.campType && info.campType != 2)
                        ? true
                        : false,
                  }"
                  @click="tapAitypHandle('2')"
                  hoverable
                >
                  <a-checkbox
                    :class="[lang]"
                    :disabled="
                      selectedAll || (info.campType && info.campType != 2)
                        ? true
                        : false
                    "
                    :checked="selectedAll || aiType === '2' ? true : false"
                    >{{ $t("AIRecruiter") }}</a-checkbox
                  >
                  <div class="desc" :class="[lang]">
                    {{ $t("SmartRecruiter") }}
                  </div>
                </a-card>
              </a-col>
              <a-col :xs="24" :sm="12" class="ai-card-col">
                <a-card
                  :class="{
                    selected: selectedAll || aiType === '1' ? true : false,
                    disabled:
                      selectedAll || (info.campType && info.campType != 1)
                        ? true
                        : false,
                  }"
                  @click="tapAitypHandle('1')"
                  hoverable
                >
                  <a-checkbox
                    :class="[lang]"
                    :disabled="
                      selectedAll || (info.campType && info.campType != 1)
                        ? true
                        : false
                    "
                    :checked="selectedAll || aiType === '1' ? true : false"
                    >{{ $t("AISslesRep") }}</a-checkbox
                  >
                  <div class="desc" :class="[lang]">
                    {{ $t("SmartSales") }}
                  </div>
                </a-card>
              </a-col>
            </a-row>
            <!-- <div class="section-title" :class="[lang]">
              {{ $t("invoiceInformation") }}
            </div>
            <a-radio-group v-model="is_personal" style="display: none" class="mb16">
              <a-radio-button value="1" :class="[lang]">{{
                $t("Soloentrepreneur")
                }}</a-radio-button>
              <a-radio-button value="2" :class="[lang]">{{
                $t("ForEnterprises")
                }}</a-radio-button>
            </a-radio-group> -->
            <a-form-model
              v-if="edit"
              ref="form"
              :model="form"
              :rules="rules"
              :label-col="{ span: 24 }"
              :wrapper-col="{ span: 24 }"
              class="billing-form"
            >
              <div class="section-title">{{ $t("invoiceInformation") }}</div>
              <div class="billInfo">
                <div class="section-title2">{{ $t("BillingContact") }}</div>
                <a-row :gutter="16">
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      :label="$t('UserType')"
                      prop="is_personal"
                      required
                      key="5"
                    >
                      <a-select
                        v-model="form.is_personal"
                        :placeholder="$t('SelectUserType')"
                      >
                        <a-select-option :class="[lang]" key="1111" value="1">
                          {{ $t("Soloentrepreneur") }}
                        </a-select-option>
                        <a-select-option :class="[lang]" key="1112" value="2">
                          {{ $t("ForEnterprises") }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      :label="$t('Firstname')"
                      prop="first_name"
                      key="1"
                      required
                    >
                      <a-input
                        v-model="form.first_name"
                        :placeholder="$t('EnterFirst')"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      :label="$t('lastName')"
                      prop="last_name"
                      required
                      key="2"
                    >
                      <a-input
                        v-model="form.last_name"
                        :placeholder="$t('EnterLastName')"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      key="6"
                      :label="$t('Email')"
                      prop="email"
                      required
                    >
                      <a-input
                        v-model="form.email"
                        :placeholder="$t('enterEmail')"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16" v-if="form.is_personal == 1">
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      key="7"
                      :label="$t('industry')"
                      prop="industry_id"
                      required
                    >
                      <a-select
                        v-model="form.industry_id"
                        :placeholder="$t('selectInstry')"
                      >
                        <a-select-option
                          :class="[lang]"
                          v-for="(item, index) in industryList"
                          :key="index"
                          :value="index"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="24" :sm="12" v-if="form.industry_id == 15">
                    <a-form-model-item
                      key="8"
                      :label="$t('Enteryourindustry')"
                      prop="industry_desc"
                      required
                    >
                      <a-input
                        v-model="form.industry_desc"
                        :placeholder="$t('Pleaseenteryourindustry')"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16" v-if="form.is_personal == 2">
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      key="7"
                      :label="$t('industry')"
                      prop="industry_id"
                      required
                    >
                      <a-select
                        v-model="form.industry_id"
                        :placeholder="$t('selectInstry')"
                      >
                        <a-select-option
                          :class="[lang]"
                          v-for="(item, index) in industryList"
                          :key="index"
                          :value="index"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="24" :sm="12" v-if="form.industry_id == 15">
                    <a-form-model-item
                      key="8"
                      :label="$t('Enteryourindustry')"
                      prop="industry_desc"
                      required
                    >
                      <a-input
                        v-model="form.industry_desc"
                        :placeholder="$t('Pleaseenteryourindustry')"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col
                    :xs="24"
                    :sm="12"
                    v-else-if="form.is_personal == 2 && form.industry_id != 15"
                  >
                    <a-form-model-item
                      key="3"
                      :label="$t('Companyname')"
                      prop="company_name"
                      required
                    >
                      <a-input
                        v-model="form.company_name"
                        :placeholder="$t('enterCompanyname')"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <template
                  v-if="form.is_personal == 2 && form.industry_id == 15"
                >
                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="3"
                        :label="$t('Companyname')"
                        prop="company_name"
                        required
                      >
                        <a-input
                          v-model="form.company_name"
                          :placeholder="$t('enterCompanyname')"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="4"
                        :label="$t('Companysize')"
                        prop="size_id"
                        required
                      >
                        <a-select
                          v-model="form.size_id"
                          :placeholder="$t('selectcompanysize')"
                        >
                          <a-select-option
                            :class="[lang]"
                            v-for="(item, index) in companyList"
                            :key="index"
                            :value="index"
                            >{{ item }}</a-select-option
                          >
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>

                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        :label="$t('Positon')"
                        prop="role_id"
                        key="9"
                        required
                      >
                        <a-select
                          v-model="form.role_id"
                          :placeholder="$t('selectposition')"
                        >
                          <a-select-option
                            :class="[lang]"
                            v-for="(item, index) in roleList"
                            :key="index"
                            :value="index"
                          >
                            {{ item }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :xs="24" :sm="12" v-if="form.role_id == 6">
                      <a-form-model-item
                        key="10"
                        :label="$t('Enteryourposition')"
                        prop="custom_role"
                        required
                      >
                        <a-input
                          v-model="form.custom_role"
                          :placeholder="$t('pleaseEnterPos')"
                        />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </template>
                <template
                  v-if="form.is_personal == 2 && form.industry_id != 15"
                >
                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="4"
                        :label="$t('Companysize')"
                        prop="size_id"
                        required
                      >
                        <a-select
                          v-model="form.size_id"
                          :placeholder="$t('selectcompanysize')"
                        >
                          <a-select-option
                            :class="[lang]"
                            v-for="(item, index) in companyList"
                            :key="index"
                            :value="index"
                            >{{ item }}</a-select-option
                          >
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        :label="$t('Positon')"
                        prop="role_id"
                        key="9"
                        required
                      >
                        <a-select
                          v-model="form.role_id"
                          :placeholder="$t('selectposition')"
                        >
                          <a-select-option
                            :class="[lang]"
                            v-for="(item, index) in roleList"
                            :key="index"
                            :value="index"
                          >
                            {{ item }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12" v-if="form.role_id == 6">
                      <a-form-model-item
                        key="10"
                        :label="$t('Enteryourposition')"
                        prop="custom_role"
                        required
                      >
                        <a-input
                          v-model="form.custom_role"
                          :placeholder="$t('pleaseEnterPos')"
                        />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </template>
              </div>
              <div class="billInfo">
                <div class="section-title2">{{ $t("BillingAddress") }}</div>
                <a-row :gutter="16">
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      :label="$t('CountryRegion')"
                      prop="country_id"
                      required
                      key="5"
                    >
                      <a-select
                        v-model="form.country_id"
                        :placeholder="$t('SelectCountryRegion')"
                      >
                        <a-select-option
                          :class="[lang]"
                          v-for="(item, index) in locationList"
                          :key="index"
                          :value="item.id"
                        >
                          {{ item.show_name }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      key="101"
                      :label="$t('State')"
                      prop="state"
                      required
                    >
                      <a-input
                        v-model="form.state"
                        :placeholder="$t('PleaseEnterState')"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      key="102"
                      :label="$t('StreetAddress')"
                      prop="street_address"
                      required
                    >
                      <a-input
                        v-model="form.street_address"
                        :placeholder="$t('PleaseEnterStreetAddress')"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      key="103"
                      :label="$t('City')"
                      prop="city"
                      required
                    >
                      <a-input
                        v-model="form.city"
                        :placeholder="$t('PleaseEnterCity')"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :xs="24" :sm="12">
                    <a-form-model-item
                      key="102"
                      :label="$t('ZipCode')"
                      prop="zip_code"
                      required
                    >
                      <a-input
                        v-model="form.zip_code"
                        :placeholder="$t('PleaseEnterZipCode')"
                      />
                    </a-form-model-item>
                  </a-col>
                  <!-- <a-col :xs="24" :sm="12">
                    <a-form-model-item key="103" label="City" prop="city" required>
                      <a-input v-model="form.city" placeholder="Please enter your city" />
                    </a-form-model-item>
                  </a-col> -->
                </a-row>
              </div>
            </a-form-model>

            <a-form-model
              v-else
              ref="form"
              :model="form"
              :label-col="{ span: 24 }"
              :wrapper-col="{ span: 24 }"
              class="billing-form"
            >
              <div class="section-title">
                <span> {{ $t("invoiceInformation") }}</span
                ><a-button class="edit" @click="editInvoiceInfo">{{
                  $t("EditInSetting")
                }}</a-button>
              </div>
              <div
                class="billInfo"
                style="
                  border: 1px solid #52c41a;
                  background: #f6ffed;
                  -webkit-transition: border 0.2s, background 0.2s;
                  transition: border 0.2s, background 0.2s;
                "
              >
                <div v-if="form.is_personal == 1">
                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        :label="$t('Firstname')"
                        class="infoBold"
                        prop="first_name"
                        key="1"
                      >
                        {{ form.first_name }}
                      </a-form-model-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        :label="$t('lastName')"
                        class="infoBold"
                        prop="last_name"
                        key="2"
                      >
                        {{ form.last_name }}
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="6"
                        :label="$t('Email')"
                        prop="email"
                        class="infoBold"
                      >
                        {{ form.email }}
                      </a-form-model-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="102"
                        :label="$t('StreetAddress')"
                        prop="address"
                        class="infoBold"
                      >
                        {{ form.street_address }}
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        :label="$t('CountryRegion')"
                        prop="country_id"
                        key="5"
                        class="infoBold"
                      >
                        {{ getCountryName(form.country_id) }}
                      </a-form-model-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="101"
                        :label="$t('State')"
                        prop="state"
                        class="infoBold"
                      >
                        {{ form.state }}
                      </a-form-model-item>
                    </a-col>
                  </a-row>

                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="103"
                        :label="$t('City')"
                        prop="city"
                        class="infoBold"
                      >
                        {{ form.city }}
                      </a-form-model-item>
                    </a-col>
                    <a-row :gutter="16">
                      <a-col :xs="24" :sm="12">
                        <a-form-model-item
                          key="102"
                          :label="$t('ZipCode')"
                          prop="zip_code"
                          class="infoBold"
                        >
                          {{ form.zip_code }}
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-row>
                </div>
                <div v-if="form.is_personal == 2">
                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="3"
                        :label="$t('Companyname')"
                        prop="company_name"
                        class="infoBold"
                      >
                        {{ form.company_name }}
                      </a-form-model-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="6"
                        :label="$t('Email')"
                        prop="email"
                        class="infoBold"
                      >
                        {{ form.email }}
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="102"
                        :label="$t('StreetAddress')"
                        prop="street_address"
                        class="infoBold"
                      >
                        {{ form.street_address }}
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        :label="$t('CountryRegion')"
                        prop="country_id"
                        key="5"
                        class="infoBold"
                      >
                        {{ getCountryName(form.country_id) }}
                      </a-form-model-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="101"
                        :label="$t('State')"
                        prop="state"
                        class="infoBold"
                      >
                        {{ form.state }}
                      </a-form-model-item>
                    </a-col>
                  </a-row>

                  <a-row :gutter="16">
                    <a-col :xs="24" :sm="12">
                      <a-form-model-item
                        key="103"
                        :label="$t('City')"
                        prop="city"
                        class="infoBold"
                      >
                        {{ form.city }}
                      </a-form-model-item>
                    </a-col>
                    <a-row :gutter="16">
                      <a-col :xs="24" :sm="12">
                        <a-form-model-item
                          key="102"
                          :label="$t('ZipCode')"
                          prop="zip_code"
                          class="infoBold"
                        >
                          {{ form.zip_code }}
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-row>
                </div>
              </div>
            </a-form-model>
          </div>
          <div class="right">
            <a-card
              v-if="$route.query.type != 4"
              class="order-detail"
              style="margin-bottom: 16px"
            >
              <div class="order-title">{{ $t("Havediscount") }}</div>
              <div class="discount-code">
                <a-input
                  v-model="discountCode"
                  :placeholder="$t('Entervalidcode')"
                />
                <a-button
                  type="primary"
                  @click="applyDiscount"
                  style="padding: 0 10px"
                  >{{ $t("Confirm") }}</a-button
                >
              </div>
              <div
                class="discount-desc"
                :style="{ color: codeInfo == 'success' ? 'green' : 'red' }"
              >
                {{ codeInfo }}
              </div>
            </a-card>
            <a-card class="order-detail">
              <div class="order-title" :class="[lang]">
                {{ $t("Orderdetail") }}
              </div>
              <div class="order-row" :class="[lang]">
                <span class="text">
                  <dl style="margin: 0">
                    <dt class="text" :class="[lang]">
                      <template v-if="info.type == 1">
                        {{ $t("liteplan") }}
                      </template>
                      <template v-if="info.type == 2">
                        {{ $t("Proplan") }}
                      </template>
                      <template v-if="info.type == 3">
                        {{ $t("PrimePlan2") }}
                      </template>
                      <template v-if="info.type == 4">
                        {{ $t("FreeTrial") }}
                      </template>
                    </dt>
                    <dd class="des" style="margin: 0" :class="[lang]">
                      <template v-if="selectedAll">
                        {{ $t("SalesRep") }}& {{ $t("Recruiter") }}
                      </template>
                      <template v-else-if="aiType == '1'">
                        {{ $t("SalesRep") }}
                      </template>
                      <template v-else-if="aiType == '2'">
                        {{ $t("Recruiter") }}
                      </template>
                      <template v-else-if="aiType == ''">
                        {{ $t("PleaseselecteAI") }}
                      </template>
                    </dd>
                  </dl>
                </span>
                <span class="price" :class="[lang]"
                  >${{
                    info.duration_type == 2
                      ? planInfo.price
                      : planInfo.original_price
                  }}</span
                >
              </div>
              <template v-if="info.type != 4">
                <div
                  :class="[lang]"
                  class="order-row"
                  v-if="info.duration_type == 2 || info.duration_type == 3"
                >
                  <span class="text" :class="[lang]">{{
                    $t("Billingcycle")
                  }}</span>
                  <span class="link" :class="[lang]">{{
                    info.duration_type == 2
                      ? $t("Monthlypayment")
                      : $t("Annualpayment")
                  }}</span>
                </div>
                <div
                  class="order-row"
                  v-if="info.duration_type == 3"
                  :class="[lang]"
                >
                  <span class="text">{{ $t("AnnualDiscount") }}</span>
                  <span class="discount"
                    >- ${{
                      (planInfo.original_price - planInfo.price).toFixed(2)
                    }}</span
                  >
                </div>
              </template>
              <p>{{ $t("Tax") }}</p>

              <div
                class="order-row"
                :class="[lang]"
                v-if="planInfo.discount_price"
              >
                <span class="text">{{ $t("Extradiscount") }}</span>
                <span class="discount">- ${{ planInfo.discount_price }}</span>
              </div>

              <div class="order-row total" :class="[lang]">
                <span class="text">{{ $t("Totalprice") }}</span>
                <span class="total-price">${{ planInfo.price }}</span>
              </div>
              <a-button
                :class="[lang]"
                type="primary"
                block
                class="pay-btn"
                @click="submitForm"
                >{{
                  $route.query.type == 4 ? $t("Confirm") : $t("Paynow")
                }}</a-button
              >
            </a-card>
          </div>
        </div>
      </a-card>
      <prime-upgrade-modal
        v-if="showModal"
        @close="showModal = false"
        @upgrade="onUpgrade"
      />
    </div>
  </a-spin>
</template>

<script>
import PrimeUpgradeModal from "./components/PrimeUpgradeModal.vue";
import Step from "./Step.vue";

export default {
  name: "Subscribe",
  components: {
    PrimeUpgradeModal,
    Step,
  },
  created() {
    this.info = this.$route.query;
    let { type } = this.info;
    if (type == 3) {
      this.selectedAll = true;
    }

    this.initData();
  },
  i18n: require("./subi18n"),
  data() {
    let that = this;
    return {
      aiType: "",
      edit: false,
      selectedAll: false,
      showModal: false,
      loading: false,
      isLtd: false,
      userInfo: {},
      discountCode: "",
      codeInfo: "",
      form: {
        is_personal: "1",
        first_name: "",
        last_name: "",
        country_id: undefined,
        email: "",
        company_name: "",
        size_id: undefined,
        role_id: undefined,
        custom_role: undefined,
        industry_id: null,
        industry_desc: undefined,
        zip_code: "",
        state: "",
        street_address: "",
        city: "",
      },
      rules: {
        first_name: [
          {
            required: true,
            message: that.$t("EnterFirst"),
            trigger: "blur",
          },
        ],
        last_name: [
          {
            required: true,
            message: that.$t("EnterLastName"),
            trigger: "blur",
          },
        ],
        country_id: [
          {
            required: true,
            message: that.$t("Plaseselectlocation"),
            trigger: "change",
          },
        ],
        industry_id: [
          {
            required: true,
            message: that.$t("selectInstry"),
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            message: that.$t("enterEmail"),
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: that.$t("correctemial"),
            trigger: "blur",
          },
        ],
        company_name: [
          {
            required: true,
            message: that.$t("enterCompanyname"),
            trigger: "blur",
          },
        ],
        size_id: [
          {
            required: true,
            message: that.$t("selectcompanysize"),
            trigger: "change",
          },
        ],
        role_id: [
          {
            required: true,
            message: that.$t("selectposition"),
            trigger: "change",
          },
        ],
        custom_role: [
          {
            required: true,
            message: that.$t("pleaseEnterPos"),
            trigger: "blur",
          },
        ],
        industry_desc: [
          {
            required: true,
            message: that.$t("Pleaseenteryourindustry"),
            trigger: "blur",
          },
        ],
        street_address: [
          {
            required: true,
            message: that.$t("PleaseEnterStreetAddress"),
            trigger: "blur",
          },
        ],
        zip_code: [
          {
            required: true,
            message: that.$t("PleaseEnterZipCode"),
            trigger: "blur",
          },
        ],
        state: [
          {
            required: true,
            message: that.$t("PleaseEnterState"),
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: that.$t("PleaseEnterCity"),
            trigger: "blur",
          },
        ],
      },
      currentInfo: [],
      roleList: [],
      companyList: [],
      locationList: [],
      planInfo: {},
      industryList: {},
      info: {},
    };
  },
  watch: {
    lang() {
      this.getPublicList();
    },
  },
  methods: {
    editInvoiceInfo() {
      this.edit = true;
    },
    getCountryName(country_id) {
      const country = this.locationList.find((item) => item.id === country_id);
      return country ? country.show_name : "";
    },
    applyDiscount() {
      if (!this.discountCode) {
        return;
      }
      this.$axios(
        "/public/calculate_discount",
        {
          discount_code: this.discountCode ? this.discountCode.trim() : null,
          subscription_plan_id: this.planInfo.id,
        },
        "post",
      ).then((res) => {
        if (res.code == 200) {
          this.codeInfo = res.msg;
          const { discount_code, discount_price, price } = res.data;
          // this.$set(this.planInfo, "price", base_price);
          // this.$set(this.planInfo, "discount_amount", discount_amount);
          this.$set(this.planInfo, "price", price);
          this.$set(this.planInfo, "discount_price", discount_price);
          this.$set(this.planInfo, "discount_code", discount_code);
        } else {
          this.codeInfo = res.msg;
          if (this.info.type == 1) {
            this.$set(
              this.$data,
              "planInfo",
              JSON.parse(JSON.stringify(this.currentInfo[0])),
            );
            // this.planInfo = this.currentInfo[0];
          } else if (this.info.type == 2) {
            // this.planInfo = this.currentInfo[1];
            this.$set(
              this.$data,
              "planInfo",
              JSON.parse(JSON.stringify(this.currentInfo[1])),
            );
          } else if (this.info.type == 3) {
            // this.planInfo = this.currentInfo[2];
            this.$set(
              this.$data,
              "planInfo",
              JSON.parse(JSON.stringify(this.currentInfo[2])),
            );
          }
        }
      });
    },
    tapAitypHandle(aiType) {
      if (this.selectedAll) {
        return;
      }
      if (this.$route.query.campType == 1 || this.$route.query.campType == 2) {
        return;
      }
      this.aiType = aiType;
    },
    initData() {
      let { duration_type, type, campType } = this.info;
      if (campType) {
        this.aiType = campType == 1 || campType == 2 ? campType : "";
      }
      let typeList = ["1", "2", "3", "4"];

      let duration_typeList = ["2", "3"];
      if (
        !typeList.includes(type) ||
        !duration_typeList.includes(duration_type)
      ) {
        alert(this.$t("queryValid"));
        return;
      }

      this.loading = true;
      if (duration_type == 2 || duration_type == 3) {
        this.$axios(
          "/payment/plan_list",
          {
            duration_type: parseInt(duration_type),
          },
          "post",
        ).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.currentInfo = res.data;
            if (type == 1) {
              this.planInfo = this.currentInfo[1];
            } else if (type == 2) {
              this.planInfo = this.currentInfo[2];
            } else if (type == 3) {
              this.planInfo = this.currentInfo[3];
            } else if (type == 4) {
              this.planInfo = this.currentInfo[4];
            }
          }
        });
      }
      this.getPublicList();
    },
    getPublicList() {
      const role = this.$axios(
        "/public/custom_role_config",
        {
          landing_page: 1,
        },
        "post",
      );
      const company = this.$axios("/public/company_size_config", {}, "post");
      const location = this.$axios("/public/country_config", {}, "post");
      const industry = this.$axios("/public/industry_config", {}, "post");
      const info = this.$axios("/payment/ext_info_list", {}, "post");
      Promise.all([role, company, location, industry, info]).then(
        ([res1, res2, res3, res4, res5]) => {
          this.roleList = res1.data;
          this.companyList = res2.data;
          this.locationList = res3.data;
          this.industryList = res4.data;
          let info = res5.data || [];
          info = info[0] || {};

          this.userInfo = info;
          let { industry_id, role_id, size_id } = info;
          industry_id = industry_id ? industry_id : 0;
          this.edit = info.city ? false : true;
          this.form = {
            ...this.form,
            ...info,
            industry_id: industry_id + "",
            role_id: role_id ? role_id + "" : null,
            size_id: size_id ? size_id + "" : null,
            is_personal:
              info.is_personal == 1 || info.is_personal == 2
                ? info.is_personal + ""
                : this.form.is_personal,
          };
        },
      );
    },

    onUpgrade() {
      // 处理升级逻辑
      this.info.type = "3";
      this.planInfo = this.currentInfo[3];

      this.showModal = false;
      this.selectedAll = true;
    },
    showUpgradeModal() {
      this.showModal = true;
      this.writeLog("plan", "page_click", "explore_prime");
    },
    generateUUIDNoDash() {
      return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    submitForm() {
      let { duration_type, type } = this.info;

      let typeList = ["1", "2", "3", "4"];

      let duration_typeList = ["2", "3"];
      if (
        !typeList.includes(type) ||
        !duration_typeList.includes(duration_type)
      ) {
        this.$warning({
          content: this.$t("queryValid"),
          okText: this.$t("Confirm"),
          onOk() {},
        });
        return;
      }

      // 校验前先判断ref是否存在且有validate方法
      const formRef = this.$refs.form;
      if (!this.selectedAll && !this.aiType) {
        this.$warning({
          content: this.$t("selectplantype"),
          okText: this.$t("Confirm"),
          onOk() {},
        });
        return;
      }
      if (formRef && typeof formRef.validate === "function") {
        formRef.validate((valid) => {
          if (valid) {
            this.loading = true;
            this.writeLog("plan", "page_click", "pay_now");
            let { duration_type } = this.$route.query;
            let { country_id, size_id, industry_id, role_id } = this.form;
            let params = {};
            if (this.userInfo.id) {
              params.payment_ext_id = this.userInfo.id;
            }

            // if (this.infoList.length == 0) {
            //   params = {
            //     country_id,
            //     size_id: parseInt(size_id),
            //     industry_id
            //   };
            // } else {
            //   params.payment_ext_id = this.selectedInfo.id;
            // }
            if (this.planInfo.discount_code) {
              params.discount_code = this.planInfo.discount_code;
            }
            // console.log(this.$route.query.upgrade_free);

            this.$axios(
              "/payment/create_order",
              {
                ...this.$route.query,
                ...this.form,
                duration_type: parseInt(duration_type),
                campaign_type: this.selectedAll
                  ? null
                  : this.aiType == "1"
                  ? 1
                  : this.aiType == "2"
                  ? 2
                  : null,
                subscription_plan_id: this.planInfo.id,
                industry_id: industry_id ? parseInt(industry_id) : undefined,
                role_id: role_id ? parseInt(role_id) : null,
                country_id: country_id ? parseInt(country_id) : null,
                size_id: size_id ? parseInt(size_id) : null,
                is_personal: parseInt(this.form.is_personal),
                upgrade_free: this.$route.query.upgrade_free
                  ? parseInt(this.$route.query.upgrade_free)
                  : 0,
                ...params,
                campaign_id: parseInt(this.$route.query.campaign_id),
              },
              "post",
            )
              .then((res) => {
                this.loading = false;
                if (res.code == 200) {
                  // this.$message.success(res.msg);
                  if (res.data.payment_method == "stripe") {
                    window.location.href = res.data.checkout_url;
                    // this.$router.push({
                    //   path: "/setting/userSetting/stripePay",
                    //   query: {
                    //     ...this.$route.query,
                    //     ...res.data,
                    //     ...this.planInfo,
                    //     // ...disccountInfo,
                    //   },
                    // });
                  } else {
                    this.$router.push({
                      path: "/setting/userSetting/planStep3",
                      query: {
                        ...this.$route.query,
                        ...res.data,
                        // ...disccountInfo,
                      },
                    });
                  }

                  // this.$router.push({
                  //   path: "/setting/bindAccount",
                  //   query: {
                  //     order_id: res.data.order_id,
                  //     campaign_type: parseInt(campaign_type),
                  //   },
                  // });
                }
              })
              .catch((e) => {
                console.log(e);
                this.loading = false;
              });
            // const guest_id = this.generateUUIDNoDash();
            // sessionStorage.setItem("guest_id", guest_id);
            // let { industry_id, role_id, country_id, size_id } = this.form;

            // let params = {
            //   ...this.form,
            //   ...values,
            //   campType: this.info.campType,
            //   isLtd: this.isLtd,
            //   url: this.info.url,
            //   guest_id,
            //   industry_id: industry_id ? parseInt(industry_id) : undefined,
            //   role_id: role_id ? parseInt(role_id) : null,
            //   country_id: country_id ? parseInt(country_id) : null,
            //   size_id: size_id ? parseInt(size_id) : null,
            // };

            // let { path } = this.$route;
            // let url = "/public/create_guest_activation_order";
            // if (path == "/subscribeLtd") {
            //   url = "/public/create_guest_ltd_order";
            // }
            // this.$axios.post(url, params).then((res) => {
            //   this.loading = false;
            //   if (res.code == 200) {
            //     this.loading = false;
            //     location.href = res.data.payment_url;
            //   }
            // });
          } else {
            // 校验失败
            return false;
          }
        });
      } else {
        // 兼容性提示
        this.$message && this.$message.error(this.$t("formLoadError"));
      }
    },
  },
};
</script>
<style>
.ant-spin-nested-loading > div > .ant-spin {
  height: 100vh;
}

.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: fixed;
}
</style>
<style lang="less" scoped>
.subscribe-page {
  min-height: 100vh;

  .infoBold {
    /deep/.ant-form-item-children {
      font-weight: bold !important;
      color: #222;
    }
  }

  .edit-link {
    color: #1890ff;
  }

  .main-card {
    // width: 1200px;
    // max-width: 98vw;
    // margin: 0 auto;
    margin: 70px 30px 20px 30px;
    // margin-top: 112px;
    // margin-bottom: 35px;
    padding: 10px;
    border-radius: 4px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    background: #fff;
    border: none;

    // /deep/ .ant-card-body {
    //   padding: 0;
    // }
    @media (max-width: 900px) {
      width: 100vw;
      padding: 16px 0;
      border-radius: 0;
      box-shadow: none;
      margin-top: 56px;

      /deep/.ant-card-body {
        padding: 16px;
      }
    }

    @media (max-width: 600px) {
      padding: 8px 0;
      margin-top: 56px;

      /deep/.ant-card-body {
        padding: 16px;
      }
    }
  }

  .steps {
    margin-bottom: 40px;

    @media (max-width: 600px) {
      margin-bottom: 20px;

      .ant-steps-item-title {
        font-size: 12px;
      }

      .ant-steps-item {
        padding: 0 2px;
      }
    }
  }

  .content {
    display: flex;
    gap: 40px;

    @media (max-width: 900px) {
      flex-direction: column;
      gap: 16px;
    }

    @media (max-width: 600px) {
      gap: 4px;
      padding: 0 4px;
    }

    .left {
      flex: 2;
      min-width: 0;
      padding-right: 32px;
      border-right: 1px solid #f0f0f0;

      @media (max-width: 900px) {
        border-right: none;
        padding-right: 0;
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 24px;
        margin-bottom: 16px;
      }

      @media (max-width: 600px) {
        padding-bottom: 8px;
        margin-bottom: 4px;
      }

      /deep/.ant-alert-info {
        background-color: #e6f7ff;
        border: 0.02667rem solid #91d5ff;
      }

      .alertInfo {
        margin-bottom: 16px;
        padding: 12px;

        a {
          color: #0e756a;
        }
      }

      .section-title {
        font-weight: 600;
        margin-bottom: 8px;
        font-size: 17px;
        color: #222;
        display: flex;
        justify-content: space-between;

        .edit {
          color: #0e756a;
        }

        @media (max-width: 600px) {
          font-size: 14px;
          margin-bottom: 4px;
        }
      }

      .section-title2 {
        font-weight: 600;
        margin-bottom: 8px;
        font-size: 15px;
        color: #222;

        @media (max-width: 600px) {
          font-size: 13px;
          margin-bottom: 4px;
        }
      }

      .mb16 {
        margin-bottom: 16px;

        @media (max-width: 600px) {
          margin-bottom: 8px;
        }
      }

      .mb24 {
        margin-bottom: 24px;
        display: flex;

        @media (max-width: 600px) {
          margin-bottom: 8px;
          flex-direction: column;
        }

        /deep/ .ant-row {
          display: flex;
          flex-wrap: wrap;
        }

        .ai-card-col {
          @media (min-width: 601px) {
            display: flex;
          }

          @media (max-width: 600px) {
            margin-bottom: 8px;

            &:last-child {
              margin-bottom: 0;
            }
          }

          /deep/ .ant-card {
            @media (min-width: 601px) {
              width: 100%;
            }
          }
        }
      }

      .selected {
        border: 1px solid #52c41a;
        background: #f6ffed;
        transition: border 0.2s, background 0.2s;
      }

      .desc {
        color: #888;
        font-size: 13px;
        margin-top: 4px;

        @media (max-width: 600px) {
          font-size: 12px;
        }
      }

      .billing-form {
        margin-top: 16px;

        .billInfo {
          padding: 16px;
          border: #f0f0f0 solid 1px;
          border-radius: 8px;
          margin-bottom: 16px;
        }

        @media (max-width: 600px) {
          margin-top: 4px;
        }

        @media (min-width: 600px) {
          .ant-form-item-label {
            padding-right: 16px;
          }
        }

        .ant-form-item-label > label {
          font-size: 15px;

          @media (max-width: 600px) {
            font-size: 13px;
          }
        }

        .ant-input,
        .ant-select-selector {
          font-size: 15px;

          @media (max-width: 600px) {
            font-size: 13px;
            height: 36px;
          }
        }
      }
    }

    .right {
      flex: 1;
      min-width: 280px;

      @media (max-width: 900px) {
        margin-top: 16px;
        min-width: 0;
      }

      .order-detail {
        border-radius: 10px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
        background: #fafcff;

        .discount-code {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 5px;
        }

        .discount-desc {
          font-size: 13px;
          color: red;
        }

        // padding: 24px 20px 20px 20px;
        @media (max-width: 600px) {
          padding: 8px 4px;
        }

        .order-title {
          font-weight: 600;
          font-size: 20px;
          color: #000;
          margin-bottom: 18px;

          @media (max-width: 600px) {
            font-size: 14px;
            margin-bottom: 8px;
          }
        }

        .order-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 15px;

          .text {
            color: #000;
            font-weight: bold;
          }

          .des {
            font-style: italic;
            color: rgba(0, 0, 0, 0.5);
          }

          @media (max-width: 600px) {
            font-size: 12px;
            margin-bottom: 4px;
          }

          &.total {
            font-weight: bold;
            // font-size: 17px;
            margin-top: 18px;

            @media (max-width: 600px) {
              font-size: 14px;
              margin-top: 8px;
            }
          }
        }

        .price {
          color: #0e756a;
          font-weight: bold;
        }

        .discount {
          color: #0e756a;
          font-weight: bold;
        }

        .total-price {
          color: #0e756a;
          font-weight: bold;
        }

        .pay-btn {
          margin-top: 28px;
          height: 44px;
          font-size: 17px;

          @media (max-width: 600px) {
            margin-top: 8px;
            height: 36px;
            font-size: 14px;
          }
        }

        .link {
          color: #0e756a;
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
  }

  @media (max-width: 600px) {
    // padding: 8px 0 8px 0;
  }
}

/deep/.ant-steps-item-finish .ant-steps-item-title {
  color: #0e756a !important;
}

/deep/.ant-checkbox-disabled + span {
  color: #000 !important;
}

.disabled {
  cursor: not-allowed;

  /deep/.ant-checkbox {
    cursor: not-allowed;
  }

  .ant-checkbox-wrapper,
  input {
    cursor: not-allowed !important;
  }
}
</style>
